import { TextIndicator } from '@innovyze/stylovyze/lib/components';
import React from 'react';
import { ACTIONS, ACTION_STATUS } from '../../hocs/PageWrapper/utils/constants';
import { usePageWrapperContext } from '../../hocs/PageWrapper/utils/PageWrapperContext';
import { HeaderSecondary, StyledButton } from './SecondaryAction.styles';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
export default function SecondaryAction({ action }) {
    const { t } = useGlobalization();
    const { secondaryAction, pageWrapperStylovyzeFields, showSecondaryAction, isDirty, } = usePageWrapperContext();
    const [isSaved, setIsSaved] = React.useState(false);
    const hasErrors = React.useMemo(() => {
        if (pageWrapperStylovyzeFields) {
            return !!Object.entries(pageWrapperStylovyzeFields).find(([, value]) => {
                if (value.networkError) {
                    return true;
                }
            });
        }
        return false;
    }, [pageWrapperStylovyzeFields]);
    const isLoading = React.useMemo(() => {
        if (pageWrapperStylovyzeFields) {
            return !!Object.entries(pageWrapperStylovyzeFields).find(([, value]) => {
                if (value.loading) {
                    return true;
                }
            });
        }
        return false;
    }, [pageWrapperStylovyzeFields]);
    const isLoadingAndNotFocus = React.useMemo(() => {
        if (pageWrapperStylovyzeFields) {
            return !!Object.entries(pageWrapperStylovyzeFields).find(([, value]) => {
                if (value.loading && !value.focus) {
                    return true;
                }
            });
        }
        return false;
    }, [pageWrapperStylovyzeFields]);
    const status = React.useMemo(() => {
        if (!isDirty)
            return ACTION_STATUS.EMPTY;
        if (hasErrors)
            return ACTION_STATUS.FAILED;
        if (isLoadingAndNotFocus)
            return ACTION_STATUS.SAVING;
        if (isSaved && !isLoading)
            return ACTION_STATUS.SAVED;
        return ACTION_STATUS.SAVED;
    }, [isDirty, hasErrors, isLoading, isSaved, isLoadingAndNotFocus]);
    React.useEffect(() => {
        setIsSaved(true);
    }, [isDirty]);
    const hasActionStatus = status !== ACTION_STATUS.EMPTY;
    const hasContextual = !!(pageWrapperStylovyzeFields && showSecondaryAction);
    const buttonText = secondaryAction?.buttonText || 'Save';
    const { icon: Icon, iconColor, text, textColor } = ACTIONS(t)[status];
    return action || hasContextual ? (React.createElement(HeaderSecondary, { "data-testid": "SecondaryAction" },
        action,
        hasContextual && (React.createElement(React.Fragment, null,
            hasActionStatus && (React.createElement(TextIndicator, { icon: React.createElement(Icon, null), label: text, variant: "outlined", textColor: textColor, iconColor: iconColor })),
            React.createElement(StyledButton, { variant: "contained", color: "primary", disabled: isLoading || status === ACTION_STATUS.FAILED, onClick: secondaryAction?.contextualAction }, buttonText))))) : (React.createElement(React.Fragment, null));
}
